package com.essntl.features.proposal.ui.addeditproposal.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalClipboardManager
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.unit.dp
import com.essntl.features.proposal.domain.model.shareLink
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalEvent
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalState
import com.essntl.uikit.components.button.outline.EsMediumOutlineButton
import com.essntl.uikit.components.button.primary.EsMediumPrimaryButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsSmallIcon
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import core.dateformat.ui.formatDate
import kotlinx.datetime.LocalDate

@Composable
fun PublishProposal(
    state: AddEditProposalState,
    onEvent: (AddEditProposalEvent) -> Unit,
    onClose: () -> Unit,
    modifier: Modifier = Modifier,
) {
    var description by remember { mutableStateOf("") }

    val clipboardManager = LocalClipboardManager.current

    val uriHandler = LocalUriHandler.current

    Box(
        modifier = modifier
            .width(400.dp)
            .height(270.dp)
            .background(color = MaterialTheme.esColorScheme.bgPrimary)
            .padding(1.5.spacing),
    ) {
        Column(
            verticalArrangement = Arrangement.spacedBy(.5.spacing),
            modifier = Modifier.align(Alignment.TopStart),
        ) {
            Text(
                text = "Publish Proposal",
                color = MaterialTheme.esColorScheme.textPrimary,
                style = MaterialTheme.esTypography.p1Bold16,
            )

            state.getProposalHistory.data?.let { p ->
                Box(
                    modifier = Modifier.fillMaxWidth(),
                ) {
                    Row(
                        horizontalArrangement = Arrangement.Center,
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = Modifier.align(Alignment.CenterStart),
                    ) {
                        Text(
                            text = "last published on ",
                            style = MaterialTheme.esTypography.c1Medium13,
                            color = MaterialTheme.esColorScheme.textDisabled,
                        )
                        Text(
                            text = LocalDate.parse(p.createdAt.substring(0, 10)).toString().formatDate("."),
                            style = MaterialTheme.esTypography.c1Medium13,
                            color = MaterialTheme.esColorScheme.textTertiary,
                        )

                        state.getProfile.data?.let { pr ->
                            Text(
                                text = " By ",
                                style = MaterialTheme.esTypography.c1Medium13,
                                color = MaterialTheme.esColorScheme.textDisabled,
                            )
                            Text(
                                text = pr.prettyName,
                                style = MaterialTheme.esTypography.c1Medium13,
                                color = MaterialTheme.esColorScheme.textTertiary,
                            )
                        }
                    }
                }
            }
        }

        Column(
            verticalArrangement = Arrangement.spacedBy(.5.spacing),
            modifier = Modifier.align(Alignment.CenterStart),
        ) {
            Row {
                Text(
                    text = "Description",
                    color = MaterialTheme.esColorScheme.textPrimary,
                    style = MaterialTheme.esTypography.p1Medium16,
                )

                Text(
                    text = "(optional)",
                    color = MaterialTheme.esColorScheme.textTertiary,
                    style = MaterialTheme.esTypography.p1Medium16,
                )
            }

            EsInput(
                value = description,
                onValueChange = { description = it },
                placeholder = "Enter description",
                singleLine = false,
                enabled = !state.publish.isSuccess,
                minLines = 3,
                maxLines = 3,
                modifier = Modifier.fillMaxWidth(),
            )
        }

        Row(
            horizontalArrangement = Arrangement.spacedBy(.5.spacing),
            modifier = Modifier.align(
                if (state.publish.isSuccess)
                    Alignment.BottomCenter else
                    Alignment.BottomEnd,
            ),
        ) {
            if (state.publish.isSuccess)
                Box(
                    modifier = Modifier.fillMaxWidth(),
                ) {
                    Row(
                        horizontalArrangement = Arrangement.Center,
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = Modifier.align(Alignment.CenterStart),
                    ) {
                        EsSmallIcon(
                            res = EsIcons.Tick,
                            tint = Color.White,
                            modifier = Modifier
                                .clip(CircleShape)
                                .background(
                                    color = MaterialTheme.esColorScheme.bgSuccess,
                                    shape = CircleShape,
                                ),
                        )

                        Spacer(modifier = Modifier.width(.5.spacing))

                        Text(
                            text = "Successfully published",
                            style = MaterialTheme.esTypography.p1Medium16,
                            color = MaterialTheme.esColorScheme.textSuccess,
                        )
                    }

                    EsMediumPrimaryButton(
                        text = "Open link",
                        suffixIconRes = EsIcons.Browse,
                        onClick = {
                            state.getProposal.data?.let { p ->
                                uriHandler.openUri(p.shareLink)
                            }
                        },
                        modifier = Modifier.align(Alignment.CenterEnd),
                    )
                }
            else {
                EsMediumOutlineButton(
                    text = "Close",
                    onClick = onClose,
                )

                EsMediumPrimaryButton(
                    text = "Publish",
                    prefixIconRes = EsIcons.Publish,
                    loading = state.publish.isLoading,
                    onClick = {
                        onEvent(
                            AddEditProposalEvent.PublishProposal(
                                description = description,
                                clipboardManager = clipboardManager,
                            ),
                        )
                    },
                )
            }
        }
    }
}